import React from "react";

import "./App.css";
import Dashboard from "./containers/Dashboard/Dashboard";
// import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//     gtmId: "G-G0NKRGRMVH",
// };
// TagManager.initialize(tagManagerArgs);

function App() {
    return <Dashboard />;
}

export default App;
